import { KeyboardEvent, RefObject } from 'react';

export const useFocusTrapHandler =
  (elementRef: RefObject<HTMLElement>, selectors = 'button, a[href]') =>
  (e: KeyboardEvent) => {
    if (e.key !== 'Tab') return;

    const element = elementRef.current;

    if (!element) return;

    const focusableElements = element.querySelectorAll<HTMLElement>(selectors);
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement =
      focusableElements[focusableElements.length - 1];

    if (e.shiftKey && document.activeElement === firstFocusableElement) {
      lastFocusableElement.focus();
      e.preventDefault();
    } else if (!e.shiftKey && document.activeElement === lastFocusableElement) {
      firstFocusableElement.focus();
      e.preventDefault();
    }
  };
